export default __webpack_public_path__ + "static/media/cuff@2x.6af50dcd.png";